import React from 'react'

import { pluralize } from '@fourthwall/utils/dist/string'

import { SideSummary } from '../../../../../../../components/common/SideSummary'

type PostAnalyticsProps = {
  commentsCount: number
  likesCount: number
}

export const PostAnalytics = ({ commentsCount, likesCount }: PostAnalyticsProps) => (
  <SideSummary.Item title="Analytics">
    <div>
      {likesCount} {pluralize(likesCount, 'like')}
    </div>
    <div>
      {commentsCount} {pluralize(commentsCount, 'comment')}
    </div>
  </SideSummary.Item>
)
